import * as React from 'react';
import { QrCode, ScanBarcode } from 'lucide-react';
import { t } from '~i18n';
import styles from './ScanButton.module.css';

/** Which code the field expects — IMEI fields read a barcode, everything else a QR. */
export type ScanIcon = 'qr' | 'barcode';

interface ScanButtonProps {
  onClick: () => void;
  icon?: ScanIcon;
  disabled?: boolean;
}

/** The QR/barcode affordance that sits inside a device-code field. */
export const ScanButton: React.FC<ScanButtonProps> = ({ onClick, icon = 'qr', disabled }) => {
  const Icon = icon === 'barcode' ? ScanBarcode : QrCode;
  return (
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      disabled={disabled}
      title={t('deviceScan.title')}
      aria-label={t('deviceScan.title')}
    >
      <Icon size={18} strokeWidth={2} />
    </button>
  );
};
